import { render } from "./GuideTaskPage.vue?vue&type=template&id=44d0ede3&scoped=true"
import script from "./GuideTaskPage.vue?vue&type=script&lang=js"
export * from "./GuideTaskPage.vue?vue&type=script&lang=js"

import "./GuideTaskPage.vue?vue&type=style&index=0&id=44d0ede3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44d0ede3"]])

export default __exports__